module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "agree.863885d7.png";